import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {CardActionArea} from 'views/components';
import {translate} from 'views/module';

import CardBody from './CardBody';

import moment from 'moment';

// The card links by Loom's client id, because intake leads created in Loom have no legacy RN.
const Card = (props) => {
  const {item} = props;

  const [cardItem, setCardItem] = React.useState(item);
  const [isStageOverlayOpen, setIsStageOverlayOpen] = React.useState(false);

  React.useEffect(() => {
    setCardItem(item);
  }, [item]);

  const clientCareplan = cardItem.clientCarePlan;
  const clientStatusLog = cardItem.clientLastLogStatusUpdate;
  const clientId = cardItem.clientId;
  const clientName = cardItem.clientName;
  const clientCreatedAt = cardItem.createdAt;
  const status = cardItem.status;
  const callStatus = cardItem.clientCallStatus?.introCallStatus;
  const leadQuality = clientCareplan?.leadQuality;

  const handleStageChanged = (nextStatus, reason) => {
    setCardItem((current) => ({
      ...current,
      status: nextStatus,
      clientLastLogStatusUpdate: {
        status: nextStatus,
        ...reason,
        createdAt: new Date().toISOString(),
      },
    }));
  };

  const clientRelationships = React.useMemo(() => {
    const relationships = Object.values(cardItem.relationships ?? {});
    if (!relationships.length) return [];

    return relationships.slice().sort((a, b) => {
      if (a.priority !== b.priority) return a.priority - b.priority;
      return a.name.localeCompare(b.name);
    });
  }, [cardItem.relationships]);

  const primaryRelationship = clientRelationships[0];
  const notSetLabel = translate('loomLead.LoomLeadList.Card.SubtitleValue.NotSet');
  const clientLocation = clientCareplan?.generalInformation?.address || notSetLabel;
  const clientCreatedAtLabel = clientCreatedAt ? moment(clientCreatedAt).format('MMM D, YYYY') : '-';
  const caregiverCount = Object.keys(cardItem.caregivers ?? {}).length;

  const clientDaysInStage = React.useMemo(() => {
    if (!clientStatusLog) {
      return Math.floor(moment().diff(moment(clientCreatedAt), 'days', true));
    } else {
      return Math.floor(moment().diff(moment(clientStatusLog.createdAt), 'days', true));
    }
  }, [clientStatusLog, clientCreatedAt]);

  const clientDaysInStageText = React.useMemo(() => {
    return translate(
        `loomLead.LoomLeadList.Card.SubtitleValue.${clientDaysInStage === 1 ? 'Day' : 'Days'}`,
        {number: clientDaysInStage},
    );
  }, [clientDaysInStage]);

  return (
    <CardActionArea
      onClick={(event) => {
        if (!isStageOverlayOpen) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
      }}
      sx={{
        height: '100%',
        textAlign: 'left',
        width: '100%',
        minWidth: 0,
      }}
      to={`/loom_lead/${clientId}`}
    >
      <CardBody
        callStatus={callStatus}
        caregiverCount={caregiverCount}
        clientCreatedAtLabel={clientCreatedAtLabel}
        clientDaysInStageText={clientDaysInStageText}
        clientId={clientId}
        clientLocation={clientLocation}
        clientName={clientName}
        leadQuality={leadQuality}
        notSetLabel={notSetLabel}
        onStageChanged={handleStageChanged}
        onStageOverlayChange={setIsStageOverlayOpen}
        primaryRelationship={primaryRelationship}
        status={status}
      />
    </CardActionArea>
  );
};

Card.propTypes = {
  item: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(Card));
